// The only file that navigates with window.location. Integration tests set `fullPageNavigationOptions.replay` to
// replay navigations as an in-page reload, so app code must call these helpers instead of window.location.
interface NavigateToOptions {
    // Skips the new history entry, like window.location.replace.
    replace?: boolean;
}

interface FullPageNavigationOptions {
    replay?: (url: string) => void;
}

export const fullPageNavigationOptions: FullPageNavigationOptions = {};

export function navigateTo(url: string, { replace = false }: NavigateToOptions = {}) {
    if (fullPageNavigationOptions.replay) {
        fullPageNavigationOptions.replay(url);
    } else if (replace) {
        window.location.replace(url);
    } else {
        window.location.assign(url);
    }
}

export function reloadPage() {
    if (fullPageNavigationOptions.replay) {
        fullPageNavigationOptions.replay(window.location.href);
    } else {
        window.location.reload();
    }
}
